import axios from "@/libs/api.request";
// 获取批量信息
export const getPages = params => {
  return axios.request({
    url: "/authority/button",
    method: "GET",
    params
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/authority/button/${id}`,
    method: "GET"
  });
};

export const saveDetails = data => {
  return axios.request({
    url: `/authority/button/${data.id}`,
    method: "put",
    data
  });
};

export const getBtnDetails = params => {
  return axios.request({
    url: `/common/role/getMenuRoles/${params.id}`,
    method: "get"
  });
};
